import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsQueryListItem } from '@fcom/core-api';

@Component({
  selector: 'fin-teaser',
  templateUrl: './teaser.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TeaserComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  linkClicked = output<void>(); // mainly for click tracking if normal link tracking is not enough
  content = input<CmsQueryListItem>();

  emitClick(): void {
    this.linkClicked.emit();
  }
}
